var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 12.5003C16.2917 12.5003 16.6667 12.8753 16.6667 13.3337C16.6667 13.792 16.2917 14.167 15.8333 14.167C15.375 14.167 15 13.792 15 13.3337C15 12.8753 15.375 12.5003 15.8333 12.5003ZM15.8333 10.8337C14.45 10.8337 13.3333 11.9503 13.3333 13.3337C13.3333 14.717 14.45 15.8337 15.8333 15.8337C17.2167 15.8337 18.3333 14.717 18.3333 13.3337C18.3333 11.9503 17.2167 10.8337 15.8333 10.8337ZM8.33333 5.00033H4.16667V6.66699H8.33333V5.00033ZM14.1667 4.16699H11.6667V5.83366H14.1667V8.04199L11.25 11.667H8.33333V7.50033H5C3.15833 7.50033 1.66667 8.99199 1.66667 10.8337V13.3337H3.33333C3.33333 14.717 4.45 15.8337 5.83333 15.8337C7.21667 15.8337 8.33333 14.717 8.33333 13.3337H12.0833L15.8333 8.62533V5.83366C15.8333 4.91699 15.0917 4.16699 14.1667 4.16699ZM5.83333 14.167C5.375 14.167 5 13.792 5 13.3337H6.66667C6.66667 13.792 6.29167 14.167 5.83333 14.167Z",
    fill: "#5B5D65"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.452e80306ab02a1f1463003970077d2a.svg";
export { ForwardRef as ReactComponent };